import React, { useState, useEffect } from "react";

import axios from "axios";
import PostAllDataModule from "../../../Components/Reuseable/PostAllDataModule";
import AdminPostNav from "../../../Layouts/Partial/AdminPostNav";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const AllPost = () => {
  const [event_data, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/simple_post/all`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.post);
      }
    });
  }, []);

  return (
    <>
      <div className="AS">
        <AdminPostNav />
        <div className="card card-bg head-line mb-2 mt-5">
          <div className="text-light d-flex justify-content-center p-2">
            <div className="faTrophy">
              <i className="fas fa-trophy"></i>
            </div>
            <h4 className="mx-3 text-white p-2">
              <span className="livechat-card-small">All Live Post</span>
            </h4>
          </div>
        </div>
        {buffer ? (
          <LoaderPost />
        ) : (
          <PostAllDataModule
            data={event_data}
            urlLink={`/superstar-admin/post/details`}
          />
        )}
      </div>
    </>
  );
};

export default AllPost;
